export const DOCUMENT_ORIGIN = document.location.origin
